import { SET_PRINT_INSTRUCTIONS_EXPANDED, SET_PRINT_INSTRUCTIONS, RESET_PRINT_INSTRUCTIONS } from '@app/actions/_types';

const initialPrintInstructionsState = {
  printInstructions: null,
  expanded: false,
};

export default (state = initialPrintInstructionsState, { type, payload } = {}) => {
  switch (type) {
    case SET_PRINT_INSTRUCTIONS_EXPANDED:
      return { ...state, expanded: payload };
    case SET_PRINT_INSTRUCTIONS:
      return { ...state, printInstructions: payload };
    case RESET_PRINT_INSTRUCTIONS:
      return { ...initialPrintInstructionsState };
    default:
      return state;
  }
};
